<div class="parametre-donnees-module">
  <div class="parametre-donnees-module__head mb-3">
    <h5 class="mb-1 parametre-donnees-module__title">Paramètres des données — {{ moduleLabel }}</h5>
    <p class="mb-0 text-muted small">Configuration du module et des champs personnalisés.</p>
  </div>

  <ul class="nav nav-tabs parametre-donnees-module__tabs flex-nowrap overflow-auto mb-3">
    <li class="nav-item" *ngFor="let t of visibleTabs">
      <a
        class="nav-link"
        [class.active]="activeTab === t.id"
        href="javascript:void(0)"
        role="tab"
        (click)="selectTab(t.id)"
      >{{ t.label }}</a>
    </li>
  </ul>

  <div *ngIf="loadingModule" class="text-center text-muted py-5">Chargement des données…</div>

  <div class="tab-panels" *ngIf="!loadingModule">
    <div *ngIf="activeTab === 'general'" class="card parametre-donnees-module__card">
      <div class="card-body">
        <h6 class="mb-3">Options générales</h6>
        <div class="custom-control custom-switch mb-2">
          <input
            type="checkbox"
            class="custom-control-input"
            id="sw-champs-perso"
            [(ngModel)]="general.champsPersonnalisesActifs"
            (ngModelChange)="onChampsPersonnalisesChange()"
          />
          <label class="custom-control-label" for="sw-champs-perso">Activer les champs personnalisés</label>
        </div>
        <p class="text-muted small mb-3">
          Lorsque cette option est désactivée, les onglets liés aux champs personnalisés (Champs, Affichage, Règles, etc.) sont masqués.
        </p>

        <div class="custom-control custom-switch mb-2">
          <input type="checkbox" class="custom-control-input" id="sw-groupes" [(ngModel)]="general.groupesActifs" />
          <label class="custom-control-label" for="sw-groupes">Groupes</label>
        </div>
        <div class="custom-control custom-switch mb-2">
          <input type="checkbox" class="custom-control-input" id="sw-tags" [(ngModel)]="general.tagsActifs" />
          <label class="custom-control-label" for="sw-tags">Tags</label>
        </div>
        <div class="custom-control custom-switch mb-2">
          <input type="checkbox" class="custom-control-input" id="sw-variantes" [(ngModel)]="general.variantesActives" />
          <label class="custom-control-label" for="sw-variantes">Variantes</label>
        </div>

        <div class="form-group mt-3 mb-2">
          <label for="max-champs">Nombre max. de champs personnalisés</label>
          <input
            id="max-champs"
            type="number"
            class="form-control"
            style="max-width: 120px"
            min="1"
            max="500"
            [(ngModel)]="general.maxChampsPersonnalises"
          />
        </div>

        <div class="custom-control custom-switch mb-2">
          <input
            type="checkbox"
            class="custom-control-input"
            id="sw-histo"
            [(ngModel)]="general.historisationModifications"
          />
          <label class="custom-control-label" for="sw-histo">Historiser les modifications</label>
        </div>
        <div class="custom-control custom-switch">
          <input type="checkbox" class="custom-control-input" id="sw-filtres" [(ngModel)]="general.filtresAvances" />
          <label class="custom-control-label" for="sw-filtres">Filtres avancés</label>
        </div>
        <button type="button" class="btn btn-primary btn-sm mt-3" (click)="saveGeneral()">Enregistrer</button>
      </div>
    </div>

    <app-parametre-donnees-champs-tab
      *ngIf="activeTab === 'champs'"
      [moduleKey]="moduleKey"
    ></app-parametre-donnees-champs-tab>

    <app-parametre-donnees-affichage-tab
      *ngIf="activeTab === 'affichage'"
      [moduleKey]="moduleKey"
    ></app-parametre-donnees-affichage-tab>

    <app-parametre-donnees-regles-tab
      *ngIf="activeTab === 'regles'"
      [moduleKey]="moduleKey"
    ></app-parametre-donnees-regles-tab>

    <app-parametre-donnees-utilisation-tab
      *ngIf="activeTab === 'utilisation'"
      [moduleKey]="moduleKey"
    ></app-parametre-donnees-utilisation-tab>

    <app-parametre-donnees-import-tab
      *ngIf="activeTab === 'import'"
      [moduleKey]="moduleKey"
    ></app-parametre-donnees-import-tab>

    <app-parametre-donnees-export-tab
      *ngIf="activeTab === 'export'"
      [moduleKey]="moduleKey"
    ></app-parametre-donnees-export-tab>

    <app-parametre-donnees-api-tab
      *ngIf="activeTab === 'api'"
      [moduleKey]="moduleKey"
    ></app-parametre-donnees-api-tab>

    <app-parametre-donnees-historique-tab
      *ngIf="activeTab === 'historique'"
      [moduleKey]="moduleKey"
    ></app-parametre-donnees-historique-tab>
  </div>
</div>
